// A persistent, anonymous per-browser id — not tied to any account. Sent with
// every order so the backend can catch the same device claiming the ₹9
// founding-member offer twice under two different emails/phone numbers,
// which the account- and phone-based checks alone can't see.
const STORAGE_KEY = "rf_device_id";

const randomId = () =>
  crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

export function getDeviceId() {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const id = randomId();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return null; // private mode with storage blocked — order just won't carry a device id
  }
}
